import { render, staticRenderFns } from "./ColChart.vue?vue&type=template&id=592fa5f7&scoped=true&"
import script from "./ColChart.vue?vue&type=script&lang=js&"
export * from "./ColChart.vue?vue&type=script&lang=js&"
import style0 from "./ColChart.vue?vue&type=style&index=0&id=592fa5f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592fa5f7",
  null
  
)

export default component.exports